import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Card } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";


const FeesCards = () => {

  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const [reportData, setReportData] = useState({ classid: "", session_id: selectedSessionId ? selectedSessionId : "" });
  const [demandRecord, setDemandRecord] = useState();

  console.log('reportData-->', reportData);
  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };

  useEffect(() => {
    if (selectedSessionId) {
      searchDemands();
    }
  }, [reportData, selectedSessionId]);

  const searchDemands = async () => {
    try {
      const result = await schoolApi.getDemandCalculations(
        selectedSessionId
      );
      console.log("result", result)
      if (result.success) {
        setDemandRecord(result.result);
      } else {
        setDemandRecord({ finaldemand: 0, received: 0, pending_amount: 0 });
      }
    } catch (error) { }
  };

  const [filterStatus, setFilterStatus] = useState("present");

  // const getDisplayValues = () => {
  //   if (!demandRecord) {
  //     return { totalStudents: 0, demands: 0, received: 0, pending: 0 };
  //   }
  //   switch (filterStatus) {
  //     case "present":
  //       return {
  //         totalStudents: demandRecord.present_students || 0,
  //         demands: demandRecord.regular_demand || 0,
  //         received: demandRecord.regular_received || 0,
  //         pending: demandRecord.regular_pending || 0,
  //       };
  //     case "dropout":
  //       return {
  //         totalStudents: demandRecord.dropout_students || 0,
  //         demands: demandRecord.dropout_demand || 0,
  //         received: demandRecord.dropout_received || 0,
  //         pending: demandRecord.dropout_pending || 0,
  //       };
  //     case "defaulter":
  //       return {
  //         totalStudents: demandRecord.defaulter_students || 0,
  //         demands: demandRecord.defaulter_demand || 0,
  //         received: demandRecord.defaulter_received || 0,
  //         pending: demandRecord.defaulter_pending || 0,
  //       };
  //     case "all":
  //     default:
  //       return {
  //         totalStudents: demandRecord.total_students || 0,
  //         demands: demandRecord.final_demand || 0,
  //         received: demandRecord.received || 0,
  //         pending: demandRecord.pending_amount || 0,
  //       };
  //   }
  // };

  const getDisplayValues = () => {
    if (!demandRecord) {
      return { totalStudents: 0, demands: 0, received: 0, pending: 0 };
    }
    switch (filterStatus) {
      case "present":
        return {
          totalStudents: demandRecord.present_students || 0,
          demands: demandRecord.regular_demand || 0,
          received: demandRecord.regular_received || 0,
          pending: demandRecord.regular_pending || 0,
        };
      case "dropout":
        return {
          totalStudents: demandRecord.dropout_students || 0,
          demands: demandRecord.dropout_demand || 0,
          received: demandRecord.dropout_received || 0,
          pending: demandRecord.dropout_pending || 0,
        };
      case "defaulter":
        return {
          totalStudents: demandRecord.defaulter_students || 0,
          demands: demandRecord.defaulter_demand || 0,
          received: demandRecord.defaulter_received || 0,
          pending: demandRecord.defaulter_pending || 0,
        };
      case "rte":
        return {
          totalStudents: demandRecord.rte_students || 0,
          demands: demandRecord.rte_demand || 0,
          received: demandRecord.rte_received || 0,
          pending: demandRecord.rte_pending || 0,
        };
      case "non_rte":  
        return {
          totalStudents: demandRecord.non_rte_students || 0,
          demands: demandRecord.non_rte_demand || 0,
          received: demandRecord.non_rte_received || 0,
          pending: demandRecord.non_rte_pending || 0,
        };
      default:
        return {
          totalStudents: demandRecord.total_students || 0,
          demands: demandRecord.final_demand || 0,
          received: demandRecord.received || 0,
          pending: demandRecord.pending_amount || 0,
        };
    }
  };
  const displayValues = getDisplayValues();

  return (
    <div>
      <div className="d-flex align-items-center justify-content-start mb-3">
        <div className="d-flex align-items-center">
          <label className="fw-bold me-2 text-muted small mb-0">
            Filter Status:
          </label>
          <select
            className="form-select form-select-sm shadow-sm"
            style={{ width: "170px", fontWeight: "500" }}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
          
            <option value="present">Present</option>
            <option value="dropout">Dropout</option>
            <option value="defaulter">Defaulter</option>
            <option value="rte">RTE Students</option>
            {/* <option value="non_rte">Non-RTE Students</option> */}
          </select>
        </div>
      </div>

      <Row className="mb-3 g-3">
        <Col lg={3} md={6} sm={12}>
          <Card
            className="text-center p-3 shadow-sm h-100"
            style={{ borderLeft: "4px solid #198754" }}
          >
            <Row className="align-items-center">
              <Col lg={3} className="mt-2">
                <span className="fa-stack small">
                  <i
                    className="fa-solid fa-circle fa-stack-2x"
                    style={{ color: "#198754" }}
                  ></i>
                  <i
                    className="fa-solid fa-users fa-stack-1x"
                    style={{ color: "white", fontSize: "2rem" }}
                  ></i>
                </span>
              </Col>
              <Col lg={9}>
                <Card.Title className="mb-1">Total Students</Card.Title>
                <Card.Text className="display-6 mb-2 fw-bold">
                  {formatNumberWithCommas(displayValues.totalStudents)}
                </Card.Text>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col lg={3} md={6} sm={12}>
          <Card
            className="text-center p-3 shadow-sm h-100"
            style={{ borderLeft: "4px solid #D32760" }}
          >
            <Row className="align-items-center">
              <Col lg={3} className="mt-2">
                <span className="fa-stack small">
                  <i
                    className="fa-solid fa-circle fa-stack-2x"
                    style={{ color: "#D32760" }}
                  ></i>
                  <i
                    className="fa-solid fa-hand-holding-usd fa-stack-1x"
                    style={{ color: "white", fontSize: "2rem" }}
                  ></i>
                </span>
              </Col>
              <Col lg={9}>
                <Card.Title className="mb-1">Demands</Card.Title>
                <Card.Text className="display-6 mb-2 fw-bold">
                  ₹ {formatNumberWithCommas(displayValues.demands)}
                </Card.Text>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col lg={3} md={6} sm={12}>
          <Card
            className="text-center p-3 shadow-sm h-100"
            style={{ borderLeft: "4px solid #FF4233" }}
          >
            <Row className="align-items-center">
              <Col lg={3} className="mt-2">
                <span className="fa-stack small">
                  <i
                    className="fa-solid fa-circle fa-stack-2x"
                    style={{ color: "#FF4233" }}
                  ></i>
                  <i
                    className="fa-solid fa-check-circle fa-stack-1x"
                    style={{ color: "white", fontSize: "2rem" }}
                  ></i>
                </span>
              </Col>
              <Col lg={9}>
                <Card.Title className="mb-1">Received</Card.Title>
                <Card.Text className="display-6 mb-2 fw-bold">
                  ₹ {formatNumberWithCommas(displayValues.received)}
                </Card.Text>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col lg={3} md={6} sm={12}>
          <Card
            className="text-center p-3 shadow-sm h-100"
            style={{ borderLeft: "4px solid #DCE123" }}
          >
            <Row className="align-items-center">
              <Col lg={3} className="mt-2">
                <span className="fa-stack small">
                  <i
                    className="fa-solid fa-circle fa-stack-2x"
                    style={{ color: "#DCE123" }}
                  ></i>
                  <i
                    className="fa-solid fa-clock fa-stack-1x"
                    style={{ color: "white", fontSize: "2rem" }}
                  ></i>
                </span>
              </Col>
              <Col lg={9}>
                <Card.Title className="mb-1">Pending</Card.Title>
                <Card.Text className="display-6 mb-2 fw-bold">
                  ₹ {formatNumberWithCommas(displayValues.pending)}
                </Card.Text>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      ></ToastContainer>
    </div>
  );
};

export default FeesCards;
